export default __webpack_public_path__ + "static/media/m800.14eec524.png";